import {DTO} from "../../../../common/utils/types";
import {v4 as uuidv4} from "uuid";
import UploadFile from "../../../../components/upload-file";
import {HandleUploadFunctionType} from "../common/types";

export class RequiredFile {
    id: string;
    type: string;
    displayName: string;
    description: string;
    allowedFileTypes: Array<string> | null;
    maxFileSize: number | null;
    isMandatory: boolean;
    uniqueId: string;
    fileCategory: string

    constructor(requiredFile: DTO<RequiredFile>) {
        this.uniqueId = uuidv4()
        this.id = requiredFile.id
        this.type = requiredFile.type
        this.displayName = requiredFile.displayName
        this.description = requiredFile.description
        this.allowedFileTypes = requiredFile.allowedFileTypes ? requiredFile.allowedFileTypes as string[] : null
        this.maxFileSize = requiredFile.maxFileSize
        this.isMandatory = requiredFile.isMandatory
        this.fileCategory = requiredFile.fileCategory
    }

    render(handleUpload: HandleUploadFunctionType) {
        return (
            <UploadFile
                fileCategoryName={this.displayName}
                allowedFileTypes={this.allowedFileTypes!!}
                isMandatory={this.isMandatory!!}
                maximumSizeOfFileInBytes={this.maxFileSize!!}
                description={this.description}
                handleUpload={async (
                    fileToBeUploaded: File,
                    setProgress: (progress: number) => void
                ): Promise<File> => {
                    return await handleUpload(fileToBeUploaded, this, setProgress);
                }}
            />
        )
    }
}